var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
import Spinner from './spinner';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Speed = {
    fast: 0.5,
    normal: 1,
    slow: 2,
};
var getAnimation = function (animation, time) {
    switch (animation) {
        default:
            return React.createElement(Spinner, { time: time });
    }
};
var getFlexDirection = function (direction) {
    switch (direction) {
        case 'top':
            return 'column-reverse';
        case 'left':
            return 'row-reverse';
        case 'right':
            return 'row';
        default:
            return 'column';
    }
};
var getContentMargin = function (direction) {
    switch (direction) {
        case 'top':
            return 'bottom';
        case 'left':
            return 'right';
        case 'right':
            return 'left';
        default:
            return 'top';
    }
};
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  \n"], ["\n  ",
    "\n  \n"])), function (_a) {
    var background = _a.background, fullScreen = _a.fullScreen, backgroundColor = _a.backgroundColor;
    return background
        ? "\n      position: " + (fullScreen ? 'fixed' : 'absolute') + ";\n      top: 0;\n      left: 0;\n      height: " + (fullScreen ? '100vh' : '100%') + ";\n      width: " + (fullScreen ? '100vw' : '100%') + ";\n      background: " + backgroundColor + ";\n      display: flex;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n      z-index: 1;\n    "
        : "";
});
var AnimationWrapper = withProps(styled.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n\n  ", ";\n"], ["\n  align-items: center;\n\n  ",
    ";\n"])), function (_a) {
    var inline = _a.inline, contentDirection = _a.contentDirection;
    return "\n    display: " + (inline ? 'inline-flex' : 'flex') + ";\n    flex-direction: " + getFlexDirection(contentDirection) + ";\n  ";
});
var Content = withProps(styled.p)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  \n  ", "\n  \n"], ["\n  margin: 0;\n  \n  ",
    "\n  \n"])), function (_a) {
    var contentDirection = _a.contentDirection, contentColor = _a.contentColor;
    return "\n    margin-" + getContentMargin(contentDirection) + ": 8px;\n    color: " + contentColor + "\n  ";
});
var Loader = function (_a) {
    var animation = _a.animation, speed = _a.speed, inline = _a.inline, content = _a.content, contentDirection = _a.contentDirection, background = _a.background, fullScreen = _a.fullScreen, backgroundColor = _a.backgroundColor, contentColor = _a.contentColor, props = __rest(_a, ["animation", "speed", "inline", "content", "contentDirection", "background", "fullScreen", "backgroundColor", "contentColor"]);
    var time = Speed[speed];
    var animationComponent = getAnimation(animation, time);
    return (React.createElement(Wrapper, __assign({ background: background, backgroundColor: backgroundColor, fullScreen: fullScreen }, props),
        React.createElement(AnimationWrapper, { inline: inline, contentDirection: contentDirection },
            animationComponent,
            content && (React.createElement(Content, { contentColor: contentColor, contentDirection: contentDirection }, content)))));
};
Loader.defaultProps = {
    inline: false,
    speed: 'normal',
    contentDirection: 'bottom',
    background: false,
    fullScreen: false,
    contentColor: 'white',
    backgroundColor: 'rgba(0,0,0,0.7)',
};
export default Loader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Loader.js.map